<template>
    <tr>
        <td style="width: 400px;">
            <v-select
                v-model="selectedProduct"
                :options="availableProducts"
                label="label"
                :onSearch="startSearch"
                ref="selector"
                :onChange="productSelected"
            >
                <div slot="no-options">Geen producten gevonden</div>
            </v-select>
            <input type="hidden" :name="field('product_id')" v-model="productId" />
            <input type="hidden" :name="field('full_line')" v-model="fullLineJson" />
        </td>
        <td style="width: 150px;">
            <span v-text="isbn"></span>
        </td>
        <td style="width: 100px;">
            <span v-text="stock"></span>
        </td>
        <td style="width: 150px;">
            <span v-text="priceExcl"></span>
        </td>
        <td style="width: 150px;">
            <input type="number" step="0.01" v-model="price" class="form-control" :name="field('price')" />
        </td>
        <td style="width: 150px;">
            <div v-if="selectedProduct?.max_quantity > 0">
                <input type="hidden" v-model="quantity" :name="field('quantity')">
                <span v-text="selectedProduct?.max_quantity"></span>
            </div>
            <input type="number" v-model="quantity" class="form-control" :name="field('quantity')" v-else />
        </td>
        <td style="width: 100px;" v-show="!isStockMovement">
            <input type="number" step="0.01" v-model="discount" class="form-control" :name="field('discount')" />
        </td>
        <td style="width: 200px;" v-show="!isStockMovement">
            <input type="text" v-model="discountDescription" class="form-control" :name="field('discount_description')" />
        </td>
        <td style="width: 100px;">
            <input type="number" step="0.01" v-model="tax" class="form-control" :name="field('tax')" />
        </td>
        <td style="width: 100px;">
            <span v-text="totalPriceExcl"></span>
        </td>
        <td>
            <button class="btn btn-danger" @click.prevent="destroy()"><i class="fa fa-close"></i></button>
        </td>
    </tr>
</template>

<script>
import vSelect from 'vue-select'
import {EventBus} from "../../events";

export default {
    name: "OrderLine",
    components: {
        'v-select': vSelect
    },
    props: {
        lineKey: {
            required: false,
            default: 1
        },
        data: {
            required: false,
            type: Object,
        },
        isStockMovement: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            quantity: 1,
            selectedProduct: null,
            isbn: "",
            priceExcl: 0,
            stock: 0,
            price: 0,
            discount: 0,
            discountDescription: "",
            tax: 0,
            productId: null,
            availableProducts: [],
            fullLineJson: "",
            pricegroup: 0,
            totalPriceExcl: 0,
        }
    },
    methods: {
        field(name) {
            return 'line['+this.lineKey+']['+name+']';
        },
        destroy() {
            EventBus.$emit('lineUpdate', {
                key: this.lineKey,
                price: 0,
            });
            this.$emit('destroy');
        },
        productSelected (val) {
            if (!this.selectedProduct) {
                this.$emit('select');
            }

            this.selectedProduct = val;
            this.fullLineJson = JSON.stringify(val);

            this.isbn = this.selectedProduct.isbn;
            this.priceExcl = this.formatPrice(this.selectedProduct.price_excl);
            this.stock = this.selectedProduct.stock;
            if(this.pricegroup == 1 || this.pricegroup == 2 || this.pricegroup == 3){
                this.price = this.formatPrice(0);
            }
            else{
                this.price = this.formatPrice(this.selectedProduct.price);
            }
            this.tax = this.selectedProduct.tax;
            this.productId = this.selectedProduct.id;
            EventBus.$emit('lineUpdate', {
                key: this.lineKey,
                price: this.price,
            });
        },
        startSearch(search, loading) {
            this.search(search, loading, this);
        },
        search: _.debounce((search, loading, vm) => {
            loading(true);
            axios.get(`/api/backend/products?search=${search}`).then(response => {
                let options = [];
                if (response.data.hasOwnProperty('data')) {
                    _.forEach(response.data.data, function(ele){
                        options.push(ele);
                    });
                }
                vm.availableProducts = options;
            }, error => {
                console.error(error);
            }).finally(() => {
                loading(false);
            });
        }, 350),
        formatPrice(price){
            return (parseFloat(price) / 100).toLocaleString(
                undefined, // leave undefined to use the browser's locale,
                // or use a string like 'en-US' to override it.
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            ).replace(",", ".");
        },
        sendLineUpdate() {
            EventBus.$emit('lineUpdate', {
                key: this.lineKey,
                price: this.price,
                discount: this.discount,
                quantity: this.quantity,
            });
            this.totalPriceExcl = this.formatPrice((parseFloat(this.price) * 100 * this.quantity));
        }
    },
    mounted() {
        if(this.data.hasOwnProperty("full_line")){
            if(this.data.full_line !== "") {
                this.selectedProduct = JSON.parse(this.data.full_line);
            }
        }
        if(this.data.hasOwnProperty("pricegroup")){
            this.pricegroup = this.data.pricegroup;
        }
        EventBus.$on('changePricegroup', (pricegroup) => {
            this.pricegroup = pricegroup;
        });
    },
    watch: {
        price: function(val) {
            this.sendLineUpdate();
        },
        discount: function(val) {
            this.sendLineUpdate();
        },
        quantity: function(val) {
            this.sendLineUpdate();
        }
    }
}
</script>

<style scoped>

</style>
